import { useMemo } from "react";
import { useAuth } from "../app/useAuth";
import { useFirestoreCollection } from "./useFirestoreCollection";
import { outgoingActiveAvailabilitySharesQuery } from "../lib/data/availability-shares";

/**
 * Phase 4 — real-time listener over the signed-in user's outgoing,
 * currently-active availability shares.
 *
 * Returns the same shape as other Firestore-collection hooks plus a
 * derived map keyed by viewerId so a per-friend lookup in the Friends &
 * Groups page is O(1).
 */
export function useOutgoingAvailabilityShares() {
  const { user } = useAuth();
  const userId = user?.uid || null;

  const queryRef = useMemo(
    () => (userId ? outgoingActiveAvailabilitySharesQuery(userId) : null),
    [userId],
  );

  const { data, loading, error } = useFirestoreCollection(queryRef);

  const sharesByViewerId = useMemo(() => {
    const map = {};
    for (const share of data) {
      if (share?.viewerId) map[share.viewerId] = share;
    }
    return map;
  }, [data]);

  return { shares: data, sharesByViewerId, loading, error };
}
